import { Actions } from './actions';
import { Cache } from './cache';
import { Size } from './size';
import css from './status.module.scss';
import { Verified } from './verified';

interface Props {
    value: string;
    onRefresh(): void;
}
export function Status({ value, onRefresh }: Props) {
    return (
        <article className={css.status}>
            <Verified value={value} />
            <Cache />
            <Size value={value} />
            <Actions value={value} onRefresh={onRefresh} />
        </article>
    );
}
